import { render, staticRenderFns } from "./SVGDownload.vue?vue&type=template&id=73ad7abf&scoped=true&"
import script from "./SVGDownload.vue?vue&type=script&lang=js&"
export * from "./SVGDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ad7abf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73ad7abf')) {
      api.createRecord('73ad7abf', component.options)
    } else {
      api.reload('73ad7abf', component.options)
    }
    module.hot.accept("./SVGDownload.vue?vue&type=template&id=73ad7abf&scoped=true&", function () {
      api.rerender('73ad7abf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGDownload.vue"
export default component.exports